import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../utils/api';
import { STORAGE_KEYS } from '../../utils/constants';

// Query Keys
export const authQueryKeys = {
  all: ['auth'],
  user: () => [...authQueryKeys.all, 'user'],
  token: () => [...authQueryKeys.all, 'token'],
};

// 로그인
export const useLogin = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ email, password }) => 
      api.post('/drivecore/id/api/Auth/signin', { email, password }),
    onSuccess: (data) => {
      
      // 로그인 성공 시 토큰만 로컬스토리지에 저장 (보안상 안전)
      const { AccessToken, RefreshToken, UserSysId, UserId, ExpiredDate, Roles } = data;
      
      
      // ✅ 토큰만 로컬스토리지에 저장
      localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, AccessToken);
      localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, RefreshToken);
      
      // ✅ 사용자 정보는 메모리(쿼리 캐시)에만 저장
      queryClient.setQueryData(authQueryKeys.user(), {
        UserSysId,
        UserId,
        AccessToken,
        RefreshToken,
        ExpiredDate,
        Roles: Roles || [] // 전체 Roles 객체를 저장 (나중에 useAuth에서 처리)
      });
    },
  });
};

// 로그아웃
export const useLogout = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userSysId) => {
      if (!userSysId) {
        throw new Error('UserSysId가 필요합니다.');
      }
      return api.post(`/drivecore/id/api/Auth/signout/${userSysId}`);
    },
    onSuccess: () => {
      // 쿼리 캐시 클리어 (로컬 스토리지 정리는 useAuth에서 처리)
      queryClient.clear();
    },
  });
};  

// 회원가입
export const useRegister = () => {
  return useMutation({
    mutationFn: ({ email, password }) => 
      api.post('/drivecore/id/api/Auth/register', { email, password }),
  });
};

// 회원탈퇴
export const useUnregister = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ email, password }) => 
      api.post('/drivecore/id/api/Auth/unregister', { email, password }),
    onSuccess: () => {
      // 회원탈퇴 성공 시 로그아웃 처리
      queryClient.clear();
      localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
      localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    },
  });
};

// 암호변경 
export const useChangePassword = () => {
  return useMutation({
    mutationFn: ({ userSysId, currentPassword, newPassword }) => 
      api.put('/drivecore/id/api/Auth/changepass', { userSysId, currentPassword, newPassword }),
  });
};

// 시스템 관리자

// 시스템 관리자 회원가입 가능여부 확인
export const useSystemAdminRegisterAvailable = (enabled = true) => {
  return useQuery({
    queryKey: ['systemAdminRegisterAvailable'],
    queryFn: async () => {
      const data = await api.get(`/drivecore/id/api/SystemAdmin/canregister`);
      return data;
    },
    enabled,
    retry: 1,
    retryDelay: 1000,
  });
};

// 시스템 관리자 회원가입
export const useSystemAdminRegister = () => {
  return useMutation({
    mutationFn: ({ email, password }) => 
      api.post('/drivecore/id/api/SystemAdmin/reigster', { email, password }),
    onSuccess: (data) => {
    },
    onError: (error) => {
      console.error(error);
    },
  });
};

// /drivecore/id/api/SystemAdmin/adduser
export const useAddUserForSystemAdmin = () => {
  return useMutation({
    mutationFn: ({ email, password }) => 
      api.post('/drivecore/id/api/SystemAdmin/adduser', { email, password }),
  });
};

// /drivecore/id/api/SystemAdmin/deluser/{UserSysId}
export const useDeleteUserForSystemAdmin = () => {
  return useMutation({
    mutationFn: ({ userSysId }) => 
      api.delete(`/drivecore/id/api/SystemAdmin/deluser/${userSysId}`),
  });
};